import config from "config/config";
export async function sendReminder(
  emailId,
  userName,
  policyId,
  premiumAmount,
  paydate,
  agentnotes,
  templateId
) {
  let ContentDictionary = {
    username: userName,
    policyid: policyId,
    premiumamount: premiumAmount?.replace("$", ""),
    paydate: paydate,
    agentnotes: agentnotes,
  };

  let options = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      ClientSecret: config.PORTAL_CLIENT_SECRET,
    },
    body: JSON.stringify({
      EmailId: emailId,
      TemplateId: templateId,
      ContentDictionary: ContentDictionary,
    }),
  };

  const response = await fetch(
    config.REG_API_BASE_URL + "/Notification/sendemail",
    options
  );

  if (response.ok) {
    return;
  } else {
    throw response;
  }
}
